"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWhitelistedError = exports.whitelistKeys = exports.errorWhitelist = void 0;
// Complete list doc: https://docs.bankstatements.com.au/#api-errors
var errorWhitelist = {
  20001: 'There have been too many unsuccessful login attempts.',
  20002: 'A required credential was not provided. Please enter all required credentials.',
  20004: 'You are currently logged in to your online banking, or have recently logged out. You will need to wait at least 15 minutes before trying again.',
  20005: 'Your online banking account has been locked. You will need to check with your bank for resetting your access.’',
  20007: 'Your online banking password has expired. You will need to check with your bank for instructions on resetting your password.',
  20008: 'The login process failed.',
  32003: 'The password does not match the one previously entered.',
  // TSB Bank requires special action(s):
  30004: "Your financial institution requires you to perform some manual action before we can export data from your account. Please log in to your financial institution's online banking (desktop site) and complete the action requested after you log in."
};
exports.errorWhitelist = errorWhitelist;
var whitelistKeys = Object.keys(errorWhitelist).map(function (n) {
  return String(n);
});
exports.whitelistKeys = whitelistKeys;

var isWhitelistedError = function isWhitelistedError(errorCode) {
  if (!errorCode) {
    return false;
  }

  return whitelistKeys.includes(errorCode.toString());
};

exports.isWhitelistedError = isWhitelistedError;